import { render } from "./used.vue?vue&type=template&id=0fcf957a&ts=true"
import script from "./used.vue?vue&type=script&lang=ts"
export * from "./used.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\www\\ctx\\Uis\\mch\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__